// Shared scroll helpers for the single-page anchor navigation.
// Kept in one place so the header, hero and footer all use the same offset.

export const HEADER_FALLBACK_OFFSET = 120;

/** Measured height of the sticky header (+ a small breathing space). */
export const getHeaderOffset = () => {
  if (typeof document === "undefined") return HEADER_FALLBACK_OFFSET;
  const header = document.querySelector("header");
  const height = header ? header.getBoundingClientRect().height : 0;
  return height || HEADER_FALLBACK_OFFSET;
};

/** Smoothly scroll a section into view, clearing the sticky header. */
export const scrollToId = (id, offset = null) => {
  const el = typeof document !== "undefined" ? document.getElementById(id) : null;
  if (!el) return;
  const headerOffset = offset ?? getHeaderOffset();
  const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
  window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });
};

/** True while a Radix overlay (sheet/dialog) still holds the body scroll lock. */
export const isScrollLocked = () => {
  if (typeof document === "undefined") return false;
  const { body } = document;
  return (
    body.hasAttribute("data-scroll-locked") ||
    window.getComputedStyle(body).overflow === "hidden" ||
    document.querySelector("[data-radix-dialog-content], [role='dialog']") !== null
  );
};

/**
 * Radix locks body scrolling while the mobile sheet is open, which makes
 * window.scrollTo a no-op. Poll until the lock is released, then scroll.
 */
export const scrollToIdWhenUnlocked = (id, attempt = 0, maxAttempts = 40) => {
  if (isScrollLocked() && attempt < maxAttempts) {
    setTimeout(() => scrollToIdWhenUnlocked(id, attempt + 1, maxAttempts), 80);
    return;
  }
  requestAnimationFrame(() => scrollToId(id));
};
